import {
    Outlet
} from "react-router-dom";
import "../styles/pagebody.css"
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";



const RouteLayout = () => {

  let bodyContent = (
    <div className="flex flex-col min-h-screen overflow-hidden hide-scrollbar bg-base">
      <div className="fixed top-0 w-full z-50">
        <NavBar />
      </div>
      <main className="mt-[136px] flex-grow overflow-auto hide-scrollbar">
        <Outlet />
      </main>
      <Footer/>
    </div>  
  );
  return bodyContent;
}
  
  export default RouteLayout